import React, { useEffect, useState, useCallback, useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import EmbeddedPdf from 'components/EmbeddedPdf'

const Nda = ({ setCallback = () => {}, match }) => {
  const { url, params: { supplierId } } = match 
  const [loading, setLoading] = useState(true)
  const [embedUrl, setEmbedUrl] = useState(null)
  const [pdfUrl, setPdfUrl] = useState(null)
  const interval = useRef(null)
  const { formatMessage } = useIntl()

  useEffect(() => {
    const abortController = new AbortController()
    const { signal } = abortController

    fetch(`/supplierNda/show?supplierId=${supplierId}`, { credentials: 'same-origin', signal })
      .then((response) => response.json())
      .then(({ success, data }) => {
        if (success) {
          setLoading(false)
          setPdfUrl(data.cdn_url)
        } else {
          fetch(`/supplierNda/create?supplierId=${supplierId}`, { credentials: 'same-origin', signal })
          .then((response) => response.json())
          .then(({ data: { embedUrl } }) => {
            setEmbedUrl(embedUrl)
            setLoading(false)
          })
          .catch((error) => {
            if (error.name !== 'AbortError') {
              window.alert(error)
            }
          })
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          window.alert(error)
        }
      })

    interval.current = setInterval(() => {
      fetch(`/rest/v2/supplier/${supplierId}/state`, { credentials: 'same-origin', signal })
        .then((response) => response.json())
        .then(() => setCallback(() => {
          return Promise.resolve()
        }))
        .catch((error) => {
          if (error.name !== 'AbortError') {
            console.error('Failed to poll supplier state:', error)
          }
        })
    }, 2000)

    return () => {
      abortController.abort()
      clearInterval(interval.current)
    }
  }, [])

  return (
    <div className="w-full h-full flex flex-col sm:flex-row divide-x sm:divide-y divide-gray-200">
      <div className="h-full w-full sm:w-2/3">
        { pdfUrl ? (
          <EmbeddedPdf pdfUrl={pdfUrl} />
        ) : embedUrl ? (
          <iframe
            className="w-full h-full"
            src={embedUrl}
          />
        ) : (
          <div className="w-full h-full bg-gray-100 flex justify-center items-center text-gray-600">
            { loading ? (
              <FormattedMessage {...messages.loading } />
            ) : (
              <FormattedMessage {...messages.error } />
            ) }
          </div>
        ) }
        </div>
      <div className="w-full sm:w-1/3 p-4 sm:p-10 xl:p-20">
        <div className="font-medium text-4xl">
          <FormattedMessage {...messages.title } />
        </div>

        <div className="text-gray-700 mt-6">
          <FormattedMessage {...messages.subtitle } />
        </div>
      </div>
    </div>
  )
}

export default Nda
